import classNames from "classnames";
import { FC } from "react";
import defectCardsStore from "../../../../store/defectCards";
import defectPopupStore from "../../../../store/defectPopup";
import styles from "../../Defect.module.scss";

const defectStatusIdCol = (context) => {
  const { setDefect, togglePopupDefect } = defectPopupStore;

  const openDefectCard = (key, planned) => {
    defectCardsStore.addCard(key, planned);
  };

  const handleOpenPopupDefect = (params): void => {
    togglePopupDefect();
    setDefect(params);
  };

  const func: FC = (text, record) => {
    return (
      <div className={styles.defectId}>
        <span
          className={classNames(
            styles.defectIdLink,
            record.minutesElapsedSinceCreation > 10080 &&
              record.minutesElapsedSinceCreation < 20160
              ? styles.defectIdLink_yellow
              : record.minutesElapsedSinceCreation > 20160 &&
                  styles.defectIdLink_red,
          )}
          // href="#"
          // onClick={(evt) => {
          //   evt.preventDefault();
          //   openDefectCard(record.id, context.planned);
          // }}
        >
          {record.id}
        </span>
        <button
          className={classNames(
            styles.defectIdBtn,
            record.incidentStatusId === 4 && styles.defectIdBtn_active,
          )}
          onClick={() => {
            handleOpenPopupDefect(record.id);
          }}
          type="button"
        />
      </div>
    );
  };
  return func;
};

export default defectStatusIdCol;
